module.exports = {
      id: "follow-gnreach-usage",
      viewBox: "0 0 131 42",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#follow-gnreach",
      toString: function () {
        return this.url;
      }
    }